// extracted by mini-css-extract-plugin
export default {"container":"styles_container__9mTBa","header":"styles_header__urgK7"};